import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import tpl from 'simple-template';
import loading from 'simple-loading';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/zoom.scss';

Component('tr-zoom', {
  mixins: [eventListenerMixin],

  properties: {
    triggerSelector: {
      type: String,
      default: '.link-zoom-trigger',
    },

    appendDialogToBody: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.listenTo(this, 'click', this.handleTriggerClick.bind(this));

    $(document).on(
      'ajax:beforeSend.tr-zoom',
      '.zoom-alert-dialog .link-create-zoom',
      this.showLoading.bind(this),
    ).on(
      'ajax:send.tr-zoom',
      '.zoom-result-dialog form',
      () => window.open(this.zoomUrl),
    ).on(
      'ajax:success.tr-zoom',
      '.zoom-result-dialog form',
      () => this.resultDialog.close(),
    );
  },

  ready() {
    this.alertDialog = this.querySelector('.zoom-alert-dialog');
    this.limitDialog = this.querySelector('.zoom-duration-limit-dialog');
    this.resultDialog = this.querySelector('.zoom-result-dialog');

    if (this.appendDialogToBody) this.hoistDialogsToBody();
  },

  beforeCache() {
    if (this.appendDialogToBody) this.restoreDialogs();
  },

  disconnected() {
    if (this.appendDialogToBody) this.restoreDialogs();
    this.stopListening();
    $(document).off('.tr-zoom');
  },

  openResultDialog({ zoomUrl }) {
    this.zoomUrl = zoomUrl;

    this.resultDialog.querySelector('.zoom-url').textContent = zoomUrl;
    this.resultDialog.querySelector('.content-field').value = tpl(
      this.querySelector('#tpl-zoom-content').innerHTML, { zoomUrl },
    );

    loading.destroy();
    this.resultDialog.open();
  },

  hoistDialogsToBody() {
    [
      this.alertDialog,
      this.resultDialog,
      this.limitDialog,
    ].filter(dialog => !!dialog).forEach((dialog) => {
      document.body.appendChild(dialog);
    });
  },

  restoreDialogs() {
    [
      this.alertDialog,
      this.resultDialog,
      this.limitDialog,
    ].filter(dialog => !!dialog).forEach((dialog) => {
      if (!this.contains(dialog)) this.appendChild(dialog);
    });
  },

  handleTriggerClick(event) {
    const trigger = closest(event.target, this.triggerSelector);
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    if (this.limitDialog) {
      this.limitDialog.open();
    } else {
      this.alertDialog.open();
    }

    const triggerDropdown = closest(trigger, '.btn-group.dropdown');
    if (triggerDropdown) triggerDropdown.classList.remove('dropdown');
  },

  showLoading(event) {
    this.alertDialog.close();

    loading({
      type: 'global',
      msg: event.currentTarget.dataset.loadingMessage,
    });
  },
});
